import Vue from 'vue';
import store from '@/store';
import VueRouter, { RouteConfig, Route } from 'vue-router';
// Layouts
import AppBar from '@/layouts/AppBar.vue';
// Components
import Home from '@/views/Home.vue';
import Gallery from '@/views/gallery/Gallery.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: { layout: [AppBar, { shrink: true }] },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: 'admin' */ '@/views/Login.vue'),
    meta: { layout: AppBar },
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import(/* webpackChunkName: 'admin' */ '@/views/Logout.vue'),
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: Gallery,
    meta: { layout: AppBar },
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: 'admin' */ '@/views/admin/GalleryAdmin.vue'),
    meta: { layout: AppBar },
    beforeEnter: (to, from, next) => {
      if (store.state.user === null) next({ name: 'login' });
      else next();
    },
  },
  { // Redirect to home page if no matching route.
    path: '*',
    redirect: { name: 'home' },
  },
];

type Position = { x: number; y: number };
const scrollBehavior = function(to: Route, from: Route, savedPosition: void|Position):
    Position | Promise<Position> | undefined | null {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 };
  }
};

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior, 
});

export default router;
